'use client'

import { memo } from 'react'
import { motion, useReducedMotion, useScroll, useTransform } from 'framer-motion'

/** Animated ledger grid backdrop */
export const NinxlBanksHeroBackground = memo(function NinxlBanksHeroBackground() {
  const shouldReduce = useReducedMotion()
  const { scrollYProgress } = useScroll()
  const gridY = useTransform(scrollYProgress, [0, 0.4], [0, -40])
  const gridOpacity = useTransform(scrollYProgress, [0, 0.35, 0.6], [1, 0.75, 0.2])

  return (
    <div className="ninxl-hero-bg pointer-events-none fixed inset-0 -z-10 overflow-hidden" aria-hidden>
      <div className="ninxl-theme-atmosphere-bg absolute inset-0" />

      <motion.div
        className="absolute inset-0"
        style={{
          y: shouldReduce ? 0 : gridY,
          opacity: shouldReduce ? 0.8 : gridOpacity,
        }}
      >
        <div className="ninxl-banks-ledger-bg ninxl-banks-ledger-bg--drift absolute inset-0 opacity-80" />
        {!shouldReduce ? (
          <>
            <div className="ninxl-banks-settlement-stream absolute inset-0" />
            <div className="ninxl-banks-ticker-fade absolute inset-0" />
          </>
        ) : null}
      </motion.div>

      <div className="absolute inset-x-0 top-0 h-[50vh] bg-gradient-to-b from-emerald-900/[0.06] via-transparent to-transparent" />
      <div className="ninxl-hero-bg-fade absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[color:var(--ninxl-theme-atmosphere)]" />
    </div>
  )
})